import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicDataLabelsBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  selector: 'ups-dynamic-data-labels',
  templateUrl: 'dynamic-data-labels.component.html',
  // WI 35584: async writes are marked in the shared dynamic-render base.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DynamicDataLabelsComponent extends DynamicDataLabelsBaseComponent {}
